var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1756881751118,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 10286,
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M900.416 330.154667a32 32 0 0 1-27.904-16.277334 383.850667 383.850667 0 0 0-165.653333-156.629333 32 32 0 0 1 28.181333-57.472 447.552 447.552 0 0 1 193.194667 182.634667 32 32 0 0 1-27.818667 47.744zM123.584 330.154667a32 32 0 0 1-27.84-47.722667 447.424 447.424 0 0 1 193.194667-182.634667 31.978667 31.978667 0 1 1 28.181333 57.472A383.829333 383.829333 0 0 0 151.466667 313.898667a32 32 0 0 1-27.882667 16.256zM512 192C306.154667 192 138.666667 359.488 138.666667 565.333333S306.154667 938.666667 512 938.666667s373.333333-167.488 373.333333-373.333334S717.845333 192 512 192z m134.058667 313.237333l-129.024 147.456a31.872 31.872 0 0 1-44.074667 3.925334l-92.16-73.728a32 32 0 1 1 39.978667-49.941334l68.245333 54.592 108.864-124.394666a31.957333 31.957333 0 0 1 45.162667-3.029334c13.312 11.605333 14.656 31.829333 3.008 45.12z",
    fill: "#0068B2",
    "p-id": 10287
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/闹钟.9e5320ef54abfebbfd44024af812e40a.svg";
export { ForwardRef as ReactComponent };